import {Wrapper as Option} from './Option.style'

export default Option